<div class="not-linked-to-account-window modal">
  <div class="content">
    <div class="title">Thank you for signing up to the FleetDynamics tracking portal. This portal displays a detailed breakdown of all vehicles movements within an organisation.</div>
    <div class="title">Unfortunately you are not currently a customer, therefore we cannot display any information.</div>
    <div class="title">If you are interested in tracking vehicles for your fleet, please get in touch with us on 1300 087 225 or via email on sales&#64;fleetdynamics.com.au</div>
  </div>
</div>
